import styled from 'styled-components';

export const StyledAboutMainSection = styled.div`
  .about-main-section {
    width: 100%;

    &__inner {
      margin: 100px auto 0 auto;
      max-width: 1200px;
      padding: 0 40px;
    }

    &__badge {
      margin-bottom: 24px;
      text-align: center;
      display: flex;
      justify-content: center;
    }

    &__title {
      margin-bottom: 20px;
      max-width: 700px;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    }

    &__accent {
      width: 60px;
      height: 3px;
      border-radius: 3px;
      background: ${({ theme }) => theme.colors.mainOrange};
      margin: 0 auto 32px auto;
    }

    &__description {
      margin-bottom: 64px;
      max-width: 740px;
      margin-left: auto;
      margin-right: auto;
      text-align: center;

      p {
        color: ${({ theme }) => theme.colors.boulder};
        line-height: 1.75;
      }
    }

    &__pillars {
      background: ${({ theme }) => theme.colors.getTransparentColor(theme.colors.mainOrange, 0.03)};
      border: 1px solid ${({ theme }) => theme.colors.getTransparentColor(theme.colors.mainOrange, 0.08)};
      border-radius: 20px;
      padding: 48px 40px;
    }

    @media (max-width: 1100px) {
      &__inner {
        margin: 50px auto 0 auto;
      }
    }

    @media (max-width: 800px) {
      &__inner {
        padding: 0 28px;
      }

      &__pillars {
        padding: 36px 20px;
      }
    }
  }
`;
